"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingEvent = void 0;
exports.TrackingEvent = {
    LOADED: "loaded",
    START: "start",
    IMPRESSION: "impression",
    COMPLETE: "complete",
    FIRST_QUARTILE: "firstQuartile",
    MIDPOINT: "midpoint",
    THIRD_QUARTILE: "thirdQuartile",
    CLICK_THROUGH: "clickThrough",
};
//# sourceMappingURL=ad.js.map